// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationWrapper__root NavigationWrapper__root___1d082"};
    if(module.hot) {
      // 1790535714786
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  